import React, { useEffect, useState } from "react";
import "./contactus.scss";
import Navbar from "../landing/header/Navbar";
import Footer from "../landing/footer/Footer";
import { submitContactUs } from "../../utils/Contactus.service";

const Contactus = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: false,
    }));

    if (status.message) {
      setStatus({ type: "", message: "" });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!form.firstName.trim()) newErrors.firstName = "First name is required.";
    if (!form.lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!form.company.trim()) newErrors.company = "Company name is required.";
    if (!form.message.trim()) newErrors.message = "Message is required.";

    if (!form.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      await submitContactUs({
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: form.email.trim(),
        company: form.company.trim(),
        message: form.message.trim(),
      });

      setForm({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        message: "",
      });
      setErrors({});
      setStatus({
        type: "success",
        message: "Your message has been sent successfully.",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: "We couldn't send your message right now. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <section className="contactus">
        <img
          src="/assets/join/darkershade.png"
          alt="darkershade"
          className="darkershade"
        />
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/assets/banner/bannervideo.mp4.mov" type="video/mp4" />
        </video>
        <div className="custom-container">
          <div className="maincontent">
            <h2 className="head">Contact Us</h2>
            <p className="para">
              Have questions about Traqstock? Reach out and our team will get
              back to you shortly.
            </p>
            <div className="mainboxcontact">
              <div className="parent">
                <div className="left">
                  <h6>Get In Touch</h6>
                  <h3>Let’s Talk About Traqstock</h3>
                  <p>
                    Have questions about Traqstock, investor verification, or
                    company onboarding? Reach out to our team and we’ll get back
                    to you shortly.
                  </p>
                  <a href="https://x.com/traqstock" target="_blank">
                    <img
                      src="\assets\twitter.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </a>
                  <div className="info">
                    <div className="innerinfo">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M2 5L8.91302 8.92462C11.4387 10.3585 12.5613 10.3585 15.087 8.92462L22 5"
                            stroke="#0F172A"
                            stroke-width="1.5"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.5 19.5C10.0337 19.4939 9.56682 19.485 9.09883 19.4732C5.95033 19.3941 4.37608 19.3545 3.24496 18.2184C2.11383 17.0823 2.08114 15.5487 2.01577 12.4814C1.99475 11.4951 1.99474 10.5147 2.01576 9.52843C2.08114 6.46113 2.11382 4.92748 3.24495 3.79139C4.37608 2.6553 5.95033 2.61573 9.09882 2.53658C11.0393 2.4878 12.9607 2.48781 14.9012 2.53659C18.0497 2.61574 19.6239 2.65532 20.755 3.79141C21.8862 4.92749 21.9189 6.46114 21.9842 9.52844C21.9939 9.98251 21.9991 10.1965 21.9999 10.5"
                            stroke="#0F172A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19 17C19 17.8284 18.3284 18.5 17.5 18.5C16.6716 18.5 16 17.8284 16 17C16 16.1716 16.6716 15.5 17.5 15.5C18.3284 15.5 19 16.1716 19 17ZM19 17V17.5C19 18.3284 19.6716 19 20.5 19C21.3284 19 22 18.3284 22 17.5V17C22 14.5147 19.9853 12.5 17.5 12.5C15.0147 12.5 13 14.5147 13 17C13 19.4853 15.0147 21.5 17.5 21.5"
                            stroke="#0F172A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <h6>info@traqstock.com</h6>
                    </div>
                    <div className="innerinfo">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M13 3C17.4183 3 21 6.58172 21 11M13.5 6.5C15.7091 6.5 17.5 8.29086 17.5 10.5"
                            stroke="#0F172A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.15825 5.71223L8.7556 4.80625C8.49232 4.21388 8.36068 3.91768 8.1638 3.69101C7.91707 3.40694 7.59547 3.19794 7.23567 3.08785C6.94858 3 6.62446 3 5.97621 3C5.02791 3 4.55375 3 4.15573 3.18229C3.68687 3.39702 3.26343 3.86328 3.09473 4.3506C2.95151 4.76429 2.99253 5.18943 3.07458 6.0397C3.94791 15.0902 8.90981 20.0521 17.9603 20.9254C18.8106 21.0075 19.2357 21.0485 19.6494 20.9053C20.1367 20.7366 20.603 20.3131 20.8177 19.8443C21 19.4462 21 18.9721 21 18.0238C21 17.3755 21 17.0514 20.9122 16.7643C20.8021 16.4045 20.5931 16.0829 20.309 15.8362C20.0823 15.6393 19.7861 15.5077 19.1937 15.2444L18.2878 14.8417C17.6462 14.5566 17.3255 14.4141 16.9995 14.3831C16.6876 14.3534 16.3731 14.3972 16.0811 14.5109C15.776 14.6297 15.5063 14.8544 14.967 15.3038C14.4301 15.7512 14.1617 15.9749 13.8337 16.0947C13.543 16.2009 13.1586 16.2403 12.8523 16.1951C12.5069 16.1442 12.2423 16.0029 11.7133 15.7201C10.0672 14.8405 9.15953 13.9328 8.27986 12.2867C7.99714 11.7577 7.85578 11.4931 7.80487 11.1477C7.75974 10.8414 7.79908 10.457 7.9053 10.1663C8.02512 9.83828 8.24881 9.56986 8.69619 9.033C9.14562 8.49368 9.37034 8.22402 9.48915 7.91891C9.60285 7.62694 9.64661 7.3124 9.61694 7.00048C9.58594 6.67452 9.44338 6.35376 9.15825 5.71223Z"
                            stroke="#0F172A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </span>
                      <h6>+1 (718) 123-4362</h6>
                    </div>
                    <div className="innerinfo">
                      <span>
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M16 10L18.1494 10.6448C19.5226 11.0568 20.2092 11.2628 20.6046 11.7942C21 12.3256 21 13.0425 21 14.4761V22" stroke="#0F172A" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M8 9H11M8 13H11" stroke="#0F172A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 22V19C12 18.0572 12 17.5858 11.7071 17.2929C11.4142 17 10.9428 17 10 17H9C8.05719 17 7.58579 17 7.29289 17.2929C7 17.5858 7 18.0572 7 19V22" stroke="#0F172A" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M2 22H22" stroke="#0F172A" stroke-width="1.5" stroke-linecap="round"/>
<path d="M3 22V6.71724C3 4.20649 3 2.95111 3.79118 2.32824C4.58237 1.70537 5.74742 2.04355 8.07752 2.7199L13.0775 4.17122C14.4836 4.57937 15.1867 4.78344 15.5933 5.33965C16 5.89587 16 6.65344 16 8.16857V22" stroke="#0F172A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      </span>
                      <h6>New York, NY</h6>
                    </div>
                  </div>
                </div>
                <div className="right">
                    <div className="upperinput">
                        <div className="firstinput">
                            <p>First Name </p>
                            <input
                              type="text"
                              name="firstName"
                              value={form.firstName}
                              onChange={handleChange}
                              placeholder="Enter first name"
                              className={errors.firstName ? "error" : ""}
                            />
                            {errors.firstName ? (
                              <span className="field-error">{errors.firstName}</span>
                            ) : null}
                        </div>
                        <div className="firstinput">
                            <p>Last Name</p>
                            <input
                              type="text"
                              name="lastName"
                              value={form.lastName}
                              onChange={handleChange}
                              placeholder="Enter last name"
                              className={errors.lastName ? "error" : ""}
                            />
                            {errors.lastName ? (
                              <span className="field-error">{errors.lastName}</span>
                            ) : null}
                        </div>
                    </div>
                    <div className="upperinput">
                        <div className="firstinput">
                            <p>Enter Email </p>
                            <input
                              type="text"
                              name="firstName"
                              value={form.firstName}
                              onChange={handleChange}
                              placeholder="Enter Email"
                              className={errors.firstName ? "error" : ""}
                            />
                            {errors.firstName ? (
                              <span className="field-error">{errors.firstName}</span>
                            ) : null}
                        </div>
                        <div className="firstinput">
                            <p>Company / Organization</p>
                            <input
                              type="text"
                              name="lastName"
                              value={form.lastName}
                              onChange={handleChange}
                              placeholder="Company / Organization"
                              className={errors.lastName ? "error" : ""}
                            />
                            {errors.lastName ? (
                              <span className="field-error">{errors.lastName}</span>
                            ) : null}
                        </div>
                    </div>
                    <div className="message">
                        <p>Message</p>
                        <textarea
                          name="message"
                          value={form.message}
                          onChange={handleChange}
                          placeholder="Tell us about your inquiry..."
                          className={errors.message ? "error" : ""}
                        />
                        {errors.message ? (
                          <span className="field-error">{errors.message}</span>
                        ) : null}
                    </div>
                    {status.message ? (
                      <p className={`status-message ${status.type}`}>{status.message}</p>
                    ) : null}
                    <button
                      className="send"
                      disabled={loading}
                      onClick={handleSubmit}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </section>
    <div className="bannerspacer"></div>
       <Footer />
    </>
  );
};

export default Contactus;
